import { useEffect } from 'react';
import { getMUICache, appendStyleSheet, getImageId, getImageUrl, getImageSize,GetFallBackImage, fetchAnchorValue } from '../../../common/utils';
// import Box from '@mui/material/Box';
// import Container from '@mui/material/Container';
// import Grid from '@mui/material/Grid';
import { CacheProvider } from '@emotion/react';
// const DEFAULT_PLACEHOLDER = "https://static.toiimg.com/photo/42706777.gif";
import "./Experts.css";
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages,PreloadViewportImages, ImageLoader} from '../../../components/IntersectionObserver/imageComponent';

const Card = (props: any) => {
  const {item, isSimilarStories, isViewport, cardTextColor, cardColor, anchorLinksValue } = props;
  const { hl, syn, imageid, pubInfo, wu, } = item;
  const cache = getMUICache();
  let styles = require("./Experts.css");
  appendStyleSheet("Experts", styles);

  let imageSize = getImageSize(imageid);

  AddImageDimensions();
  SetHighPriorityImages();
  PreloadViewportImages();
  ImageLoader();

      useEffect(()=>{
          EagerLoadImages()
      },[]);

  return (
    <CacheProvider value={cache}>
      {/* <div>
        <div className='listcontainer' style={{background:cardColor}}>
          <div className="mainlistingwrap" style={{ background: background }}> */}
      <a role="link" aria-label="Next Page" href={(wu?.startsWith('http') ? wu : (wu?.startsWith('/') ? wu : '/' + wu))} target={fetchAnchorValue(anchorLinksValue, (wu?.startsWith('http') ? wu : (wu?.startsWith('/') ? wu : '/' + wu)))} className='themeThreeExpertsWraperAnchor' style={{backgroundColor: cardColor}}>
        <div className='themeThreeExpertsWraper'>
        <div className='themeThreeExpertsImageWraper'>

          {isSimilarStories
            ?
            (imageSize && isViewport ?   <picture>
              <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(imageid), imageSize, 264, 199, pubInfo.baseDomain, false, props.CONSTANTS, '8')} />
              <source media="(max-width: 767px)" srcSet={getImageUrl(getImageId(imageid), imageSize, 190, 143, pubInfo.baseDomain, false, props.CONSTANTS, '8')} />
              (<img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy"/>)
                 
          </picture>:(imageSize && !isViewport ? <picture>
              <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(imageid), imageSize, 264, 199, pubInfo.baseDomain, false, props.CONSTANTS, '8')} />
              <source media="(max-width: 767px)" srcSet={getImageUrl(getImageId(imageid), imageSize, 190, 143, pubInfo.baseDomain, false, props.CONSTANTS, '8')} />
              (<img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy"/>)
                 
          </picture> : null))
            :
            (imageSize ?
              (<picture>
                {/* Add multiple source elements for different image sources */}
                <source media="(min-width: 768px)"  srcSet={getImageUrl(getImageId(imageid), imageSize, 264, 199, pubInfo.baseDomain, false, props.CONSTANTS, '8')} />
                <source media="(min-width: 320px)"  srcSet={getImageUrl(getImageId(imageid), imageSize, 190, 143, pubInfo.baseDomain, false, props.CONSTANTS, '8')} />
                {/* Fallback image for browsers that do not support the picture element */}
                {isViewport ? (<img  alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} />)
                  : (<img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy"/>)}
              </picture>)
              :
              <img src={GetFallBackImage()} loading="lazy"/>
              )
          }
        </div>

        <div className='themeThreeExpertsContentWraper'>
       <p className='ThemeThreeExpertsSubHeading'>Professor</p>
          <div className='themeThreeExpertsTitle' style={{ color: cardTextColor }}>
            {hl}
          </div>
          <p className="ThemeThreeExpertsDescription" style={{ color: cardTextColor }}>{syn} </p>

          {/* <div className='themeThreeExpertsDiscription'>
          <p className='ThemeThreeExpertsHeading'><a href={props.mainHeadingHref} target="_self" style={{ color: props.mainHeadingColor }}>{props.mainHeading}</a></p>
          </div> */}

        </div>
          </div>
      </a>
      {/* </div>
          <div className='clearfix'></div>
        </div> 
      </div>*/}
    </CacheProvider>
  )
}
export default Card;

